module.exports = __webpack_public_path__ + "static/media/shivyog.cbafc00e.webp";